import colors from '../../colors';

const tooltip = {
  backgroundColor: colors.primary.grey4,
  borderColor: colors.primary.ltGrey1,
  color: colors.primary.ltGrey2,
};

export default tooltip;
